
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      newItem: "",
      loading: false,
      list: {
        username: "TestUser",
        chat_id: "TestChatId",
      },
      removingId: "",
    };
  },
  methods: {
    async getItems() {
      //   this.loading = true;
      //   const res = await useHttp(`/doctor/telegram`);
      //   if (res.data.value) {
      //     list.value = res.data.value.data;
      //   }
      //   loading.value = false;
    },
    async removeItem(chat_id: string) {
      this.removingId = chat_id;
      //   await useHttp(`/doctor/telegram/${chat_id}`, {
      //     method: "DELETE",
      //   });
      //   this.removingId = "";
      //   this.getItems();
    },
    async addItem() {
      //   if (this.newItem) {
      //     try {
      //       const res = await useHttp(`/doctor/telegram`, {
      //         method: "PATCH",
      //         data: {
      //           code: this.newItem,
      //         },
      //       });
      //       if (res.data.value) {
      //         this.getItems();
      //       } else {
      //         if (res.error.value) {
      //           useNotify({ text: "Код не найден" }, NotifyType.Danger);
      //         }
      //       }
      //       this.newItem = "";
      //     } catch (error) {
      //       useNotify({ text: "Ошибка подключения оповещений" }, NotifyType.Danger);
      //       console.log(`error =>`, error);
      //     }
      //   }
    },
  },
});
